var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonDetails = function SvgPersonDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33103 28.4208C12.2706 27.109 16.5292 27.1097 20.4683 28.4227L25.5179 30.1059C27.4779 30.7593 28.8 32.5936 28.8 34.6596V38.4H0V34.6557C0 32.589 1.32278 30.7544 3.28357 30.1015L8.33103 28.4208ZM14.4 9.59998C18.3765 9.59998 21.6 12.8235 21.6 16.8C21.6 20.7764 18.3765 24 14.4 24C10.4236 24 7.2 20.7764 7.2 16.8C7.2 12.8235 10.4236 9.59998 14.4 9.59998Z",
    fill: "#B6C2D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 14.4H28.8V16.8H48V14.4Z",
    fill: "#B6C2D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 21.6H28.8V24H48V21.6Z",
    fill: "#B6C2D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28.8H33.6V31.2H48V28.8Z",
    fill: "#B6C2D6"
  })));
};
export default SvgPersonDetails;